import Cookies from "js-cookie";
import { useState, useEffect, useRef } from "react";
import { ICategory, ISubCategory } from "src/helper/interfaces";
import { TreeSelect, TreeSelectChangeEvent, TreeSelectSelectionKeysType } from 'primereact/treeselect';
import { TreeNode } from 'primereact/treenode';
import { getAllCategories } from "../pages/workers/Workers";
import { getAllSubCategories } from "../pages/workers/WorkerSubCatPage";
import { BiXCircle } from 'react-icons/bi'; // Example clear icon from react-icons
const CheckboxFilter: React.FC<{ onSelectionChange: (selectedChildren: any[]) => void }> = ({ onSelectionChange }) => {
   const Token = Cookies.get("token");
   const [categories, setCategories] = useState<ICategory[]>([]);
   const [subCategories, setSubCategories] = useState<ISubCategory[]>([]);
   const [clickedNode, setClickedNode] = useState(null); // For clicked node info
   const [clickedFilter, setClickedFilter] = useState(false);
   const [nodes, setNodes] = useState<TreeNode[]>([]);
   const [selectedNodeKeys, setSelectedNodeKeys] = useState(null);
   // const [selectedChildren, setSelectedChildren] = useState<TreeNode[]>([]); // Tracks selected child nodes
   let currentEndpoint = window.location.pathname;

   const treeSelectRef = useRef<TreeSelect>(null); // Create a ref for the TreeSelect component

   useEffect(() => {
      if (!Token) return;
      getAllCategories(Token).then((res) => {
         setCategories(res?.data?.data);
      })
         .catch((err) => {
            console.log(err)
            throw err;
         });

      getAllSubCategories(Token as string, 1, "", 100, "all").then((res) => {
         // console.log(res)
         if (res?.data?.status_code === 200) {
            setSubCategories(res?.data?.data?.data);
         }
      }).catch((err) => {
         console.log(err)
         throw err;
      });
   }, [Token, clickedFilter]);


   const handleChange = (e: any) => {
      // const updatedValue = e.value;
      setSelectedNodeKeys(e.value);

   };

   const handleNodeClick = (node: any) => {
      setClickedNode(node);

   };

   const getSelectedChildren = (
      nodes: TreeNode[],
      selectedKeys: Record<string, boolean>
   ): TreeNode[] => {
      let selected: TreeNode[] = [];

      nodes.forEach((node) => {
         // Check if the current node is selected
         if (selectedKeys[node.key as string] && (!node.children || node.children.length === 0)) {
            selected.push(node); // Add leaf node
         }

         // Recursively check children
         if (node.children && node.children.length > 0) {
            selected = selected.concat(getSelectedChildren(node.children, selectedKeys));
         }
      });

      return selected;
   };

   useEffect(() => {
      if (selectedNodeKeys) {
         const selectedKeys =
            typeof selectedNodeKeys === "object" ? (selectedNodeKeys as Record<string, boolean>) : {};
         const selected = getSelectedChildren(nodes, selectedKeys);
         // setSelectedChildren(selected);
         onSelectionChange(selected); // Notify parent about the selection change
         // console.log("Selected Children:", selected);
      }
   }, [selectedNodeKeys]);

   useEffect(() => {
      // console.log(currentEndpoint);
      if (currentEndpoint.includes("/users")) {
         // setPathName("user")
         const filterOptions = [
            {
               key: '0',
               label: 'Verified Users',
               data: 'Status Folder',
            }

         ]
         setNodes(filterOptions);
      }
      else if (currentEndpoint.includes("/workers")) {
         // setPathName("worker")  
         const filterOptions = [
            {
               key: '0',
               label: 'Services',
               data: 'Services Folder',
               // icon: 'pi pi-fw pi-inbox',
               children: [
                  {
                     key: '0-0',
                     label: 'Membership',
                     data: 'Membership',
                  },
                  {
                     key: '0-1',
                     label: 'Subscription',
                     data: 'Subscription',
                  }
               ]
            },
            {
               key: '1',
               label: 'Is Active',
               data: 'Active Folder',
               // icon: 'pi pi-fw pi-inbox',
               children: [
                  {
                     key: '1-0',
                     label: 'Active',
                     data: 'Active',
                  },
                  {
                     key: '1-1',
                     label: 'Inactive',
                     data: 'Inactive',
                  }
               ]
            },
            {
               key: '2',
               label: 'Worker Types',
               data: 'Worker Folder',
               children: categories.map((cat, i) => ({
                  key: `2-${i}`,
                  label: cat?.category_name,
                  data: cat?.category_name,
                  children: subCategories
                     .filter((sub) => sub.category_id === cat._id)
                     .map((sub, j) => ({
                        key: `2-${i}-${j}`,
                        label: sub?.sub_category_name,
                        data: cat?.type,
                     })),
               })),
            }

         ]
         setNodes(filterOptions);
      }
      else if (currentEndpoint.includes("/doorstep-orders")) {
         // setPathName("doorstep")
         const filterOptions = [
            {
               key: '0',
               label: 'Order Status',
               data: 'Status Folder',
               // icon: 'pi pi-fw pi-inbox',

               children: [
                  {
                     key: "0-0",
                     label: "Pending",
                     data: "pending",
                  },
                  {
                     key: "0-1",
                     label: "Assigned",
                     data: "assigned",
                  },
                  {
                     key: "0-2",
                     label: "Completed",
                     data: "completed",
                  },
                  {
                     key: "0-3",
                     label: "Cancelled",
                     data: "cancelled",
                  },
               ]

            },
            {
               key: '1',
               label: 'Service Types',
               data: 'Service Types Folder',
               // icon: 'pi pi-fw pi-inbox',
               children: [
                  {
                     key: '1-0',
                     label: 'Engineer Services',
                     data: 'Engineer',
                  },
                  {
                     key: '1-1',
                     label: 'Handyman Services',
                     data: 'normal_worker',
                  },
                  {
                     key: '1-2',
                     label: 'Architecture Services',
                     data: 'Architect',
                  }
               ]
            }

         ]
         setNodes(filterOptions);
      }

   }, [categories]);


   useEffect(() => {
      if (!Object.keys(selectedNodeKeys || {}).length) {
         // console.log("selectedNodeKeys: ", selectedNodeKeys)
         setSelectedNodeKeys(null); // Clear selection when no nodes are selected
      }
   }, [selectedNodeKeys]);

   const handleClearSelection = () => {
      if (treeSelectRef.current) {
         treeSelectRef.current.clear(); // Manually clear the selection when the icon is clicked
      }
      // Call the parent callback to handle API update or state reset
      onSelectionChange([]); // Send an empty array to the parent
   };

   return (
      <div className=" flex justify-content-center " style={{ width: "200px" }}>
         <TreeSelect
            ref={treeSelectRef} // Attach the ref to TreeSelect
            value={selectedNodeKeys}
            onChange={handleChange}
            options={nodes}
            metaKeySelection={false}
            onNodeSelect={(e) => handleNodeClick(e.node)} // Node select handler
            onNodeUnselect={(e) => handleNodeClick(e.node)} // Optional: Node unselect handler
            className="worker-filter d-flex "
            onClick={() => setClickedFilter(!clickedFilter)}
            selectionMode="checkbox"
            display="chip"
            placeholder="Filter Options"
            clearIcon={<BiXCircle />} // Clear icon using react-icons
         />
         <button onClick={handleClearSelection} style={{ display: 'none' }}>Clear</button> {/* Hidden Clear button */}
      </div>
   )
}

export default CheckboxFilter;